import * as React from 'react';
import { Input } from '@readcloud/ui/input';
import { Label } from '@readcloud/ui/label';
import { Card } from '@readcloud/ui/card';
import { useFormContext } from 'react-hook-form';

interface ICreateThumbnailProps {
  onThumbnailCreate: (data: string) => void;
  fileData?: { type: string; name: string };
}

const CreateThumbnail: React.FunctionComponent<ICreateThumbnailProps> = ({
  onThumbnailCreate,
  fileData,
}) => {
  const [title, setTitle] = React.useState('');
  const canvasRef = React.useRef<HTMLCanvasElement>(null);

  React.useEffect(() => {
    if (fileData) {
      const parts = fileData.name.split('.');
      const isUrl = parts[parts.length - 1] === 'com';

      if(isUrl){
        const fileName = parts.join('.');
        setTitle(fileName);
      }else{
        const fileName = parts.slice(0, -1).join('.');
        setTitle(fileName);
      }
    }
  }, [fileData]);

  React.useEffect(() => {
    const canvas = canvasRef.current;
    if (canvas) {
      const context = canvas.getContext('2d');
      if (context) {
        context.clearRect(0, 0, canvas.width, canvas.height); // Clear the canvas
        context.font = '30px Lato'; // Set font size and style
        context.textAlign = 'center'; // Center the text horizontally
        context.textBaseline = 'middle'; // Center the text vertically
        context.fillStyle = '#0056A4'; // Set text color to black
        const lineHeight = 30; // Set line height to match font size
        const lines = wrapText(context, title, canvas.width - 20); // Wrap text with padding

        lines.forEach((line, index) => {
          context.fillText(
            line,
            canvas.width / 2,
            canvas.height / 2 -
              ((lines.length - 1) * lineHeight) / 2 +
              index * lineHeight
          );
        });

        // Call handleCreate whenever the canvas is updated
        if (title.length > 0) {
          onThumbnailCreate(canvas.toDataURL());
        } else {
          onThumbnailCreate('');
        }
      }
    }
  }, [title]);

  // Helper function to wrap text
  function wrapText(context, text, maxWidth) {
    const words = text.split(' ');
    const lines: string[] = [];
    let currentLine: string = words[0];

    for (let i = 1; i < words.length; i++) {
      const word = words[i];
      const width = context.measureText(currentLine + ' ' + word).width;
      if (width < maxWidth) {
        currentLine += ' ' + word;
      } else {
        lines.push(currentLine);
        currentLine = word;
      }
    }
    lines.push(currentLine);

    // Handle long words that exceed maxWidth
    for (let i = 0; i < lines.length; i++) {
      let line = lines[i];
      while (context.measureText(line).width > maxWidth) {
        let j = line.length - 1;
        while (context.measureText(line.substring(0, j)).width > maxWidth) {
          j--;
        }
        lines[i] = line.substring(0, j);
        lines.splice(i + 1, 0, line.substring(j).trim());
        line = lines[i + 1];
      }
    }

    return lines;
  }

  return (
    <div className="rc-flex rc-flex-col rc-items-center rc-justify-center rc-gap-6 rc-w-full">
      <div className="rc-flex rc-flex-col rc-w-full rc-gap-2">
        <Label>Thumbnail Text</Label>
        <Input
          name="label"
          placeholder="Label"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
        />
      </div>

      <Card className="rc-overflow-hidden rc-w-44 rc-h-[234.47px]">
        <canvas ref={canvasRef} width="176" height="234.47px" />
      </Card>
    </div>
  );
};

export default CreateThumbnail;
